import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { UserService } from '@xanadu/service';
import { Identity } from '@xanadu/model';
import { NoticeSignal } from '@xanadu/signal';
import { AuthSignal } from '@xanadu/signal';

@Component({
    selector: 'app-password-dialog',
    templateUrl: './password-dialog.component.html',
    styleUrls: ['./password-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordDialogComponent {
    private readonly authSignal = inject(AuthSignal);
    private readonly userService = inject(UserService);
    private readonly noticeSignal = inject(NoticeSignal);
    private readonly dialogRef = inject(MatDialogRef<PasswordDialogComponent>);
    private readonly dialogData = inject(MAT_DIALOG_DATA) as Identity;

    formGroup: FormGroup = new FormGroup({});
    errMsg?: string;

    metaCurrent: any = { id: 'current', name: 'Current Password' };
    metaPassword: any = { id: 'password', name: 'New Password', mandatory: true };
    metaConfirm: any = { id: 'confirm', name: 'Confirm Password', mandatory: true };

    showCurrent: boolean = false;

    constructor() {
        effect(() => {
            const identity = this.authSignal.identity();
            this.showCurrent = identity?._id === this.dialogData._id;
        });
    }

    onSubmit() {
        const credentials = this.formGroup.value;
        this.errMsg = undefined;

        if (this.dialogData._id) {
            this.userService.password(this.dialogData._id, credentials.current, credentials.password)
                .subscribe(_ => {
                    this.dialogRef.close();
                    this.noticeSignal.info('Password is changed.');
                });
        }
    }
}
